module.exports = __webpack_public_path__ + "static/media/ada.367594dd.jpg";